<template>
  <div class="tips_page">
    <div class="banner">
      <img src="https://static-kaop.sdyxmall.com/h5/icon_404.png" />
    </div>
    <div class="tips">
      <div class="tips1">抱歉！页面无法访问……</div>
      <div class="tips2">可能因为：</div>
      <div class="tips3">
        <span>网址已失效</span>
        <span class="icon"></span>
        <span style="color: #bdc0c5; margin-left: 2px">可能商品品类已下架或活动已结束等</span>
      </div>
      <div class="tips3">
        <span>网址有错误</span>
        <span class="icon"></span>
        <span style="color: #bdc0c5; margin-left: 2px">请检查地址是否完整或存在多余字符</span>
      </div>
    </div>
  </div>
</template>

<script>
import myHeader from '../component/header'
import setDocumentTitle from '@util/document-title'
export default {
  components: {
    myHeader,
  },
  mounted() {
    setDocumentTitle('抱歉！页面无法访问')
  },
}
</script>

<style lang="less" scoped>
.tips_page {
  .banner {
    margin-top: 104px;
    text-align: center;
    img {
      width: 219px;
      height: 180px;
    }
  }
  .tips {
    margin-top: 50px;
    margin-left: 77.5px;
    .tips1 {
      height: 24px;
      font-size: 17px;
      font-weight: bold;
      color: rgba(121, 125, 130, 1);
      line-height: 24px;
    }
    .tips2 {
      margin-top: 5px;
      height: 14px;
      font-size: 10px;
      font-weight: 400;
      color: rgba(189, 192, 197, 1);
      line-height: 14px;
    }
    .tips3 {
      margin-top: 5px;
      height: 14px;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(121, 125, 130, 1);
      line-height: 14px;
      .icon {
        display: inline-block;
        width: 5px;
        height: 5px;
        border-top: 1px solid #bdc0c5;
        border-right: 1px solid #bdc0c5;
        margin: 1px;
        transform: rotate(45deg);
      }
      span {
        height: 14px;
        font-size: 10px;
        font-weight: 400;
        line-height: 14px;
      }
    }
  }
  .logo {
    position: absolute;
    bottom: 40px;
    width: 100%;
    margin: 0 auto;
    text-align: center;
    img {
      width: 115px;
      height: 37px;
    }
  }
}
</style>
